import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TreeNode} from "primeng/api";
import {PageComponent} from "../../../../../core/shared/mvs-page/page.component";
import {NavigationItem} from "../../../../../core/shared/dto/navigation/navigation-item";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";

@Component({
    selector: 'dc-docs-page',
    templateUrl: 'dc-docs.page.html',
    standalone: false
})
export class DcDocsPage extends PageComponent implements OnInit {

    selectedNode: TreeNode;

    constructor(protected route: ActivatedRoute,
                protected coreService: MvsCoreService
    ) {
        super(route, coreService);
    }

    defaultLabel: string = "DC Documentation";

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
    }

    initComponent(): void {
        this.refreshComponent();
    }

    refreshComponent(): void {
        this.initialized = true;
    }

    isNavComponent(): NavigationItem[] {
        return this.navigationItems;
    }


}
